import { gql } from '@apollo/client';
import client from '../../../core/services/graphql';

export const ORDER_PROJECTS_BY = 'created_at DESC';
export const DEBOUNCE_TIME = 700;
export const PROJECTS_LIMIT = 100;

export const USERS = gql`
    query Users($offset: Int!, $order: String!, $limit: Int!, $tableFilter: String,
      $guest: Boolean, $lastLoginMonths: Int, $status: String, $projectId: ID) {
      usersCount(tester: true, tableFilter: $tableFilter,
        guest: $guest, lastLoginMonths: $lastLoginMonths, status: $status, projectId: $projectId)
      users(tester: true, offset: $offset, order: $order, limit: $limit, tableFilter: $tableFilter,
        guest: $guest, lastLoginMonths: $lastLoginMonths, status: $status, projectId: $projectId) {
        id
        guest
        email
        lastLogin
        lastParticipated
        status
        lastInvite
        lastEmailed
        averageRating
        testsTakenNumber
        isBannedModeratedAt
        profile {
          id
          firstName
          lastName
          linkedinFields {
            educationLevel
            currentPosition {
              title
              description
              seniority
              company {
                name
                size
                industry
              }
            }
          }
          email
          birthdate
          gender
          raceEthnicHeritage
          workStatus
          annualHouseholdIncome
          smartphone
          computer
          tablet
          otherDevices
          country
          state
          languages
          zipcode
          paymentMethod
          paypalAccount
          educationLevel
          jobCategories {
            name
          }
          currentPosition {
            title
            seniority
            company {
              size
              industry
            }
          }
        }
      }
    }
  `;

export const getTesters = async ({
  offset, limit, order, ...params
}) => {
  const { data } = await client.getClient().query({
    query: USERS,
    variables: {
      ...params,
      offset,
      order,
      limit,
    },
    fetchPolicy: 'no-cache',
  });

  return data;
};

export const PROJECTS = gql`
  query Projects(
    $status: ProjectStatusEnum,
    $name: String,
    $order: String,
    $limit: Int,
    $participantsSource: [ProjectParticipantsSourceEnum!]
  ) {
    projects(
      status: $status,
      name: $name,
      order: $order,
      limit: $limit,
      participantsSource: $participantsSource
    ) {
      id
        name
      name
      segments {
        id
        name
      }
    }
  }
`;

export const INVITE_TESTERS = gql`
  mutation InviteTesters($userIds: [ID!]!, $projectId: ID!, $segmentId: ID!, $subject: String!, $message: String!) {
    inviteTesters(
      userIds: $userIds, projectId: $projectId, segmentId: $segmentId, subject: $subject, message: $message, isAdminInvite: true) {
      testers {
        id
      }
    }
  }
`;

export const PROJECT = gql`
  query Project(
    $id: ID!,
  ) {
    project(
      id: $id
    ) {
      name
      segments {
        id
        name
        audienceAttributes {
          id
          audienceAttributeType
          audienceAttributeOptions {
            id
            value
            name
          }
        }
      }
      company {
        name
      }
    }
  }
`;
